import { createContext, useContext, useState } from "react";
import axios from "axios";
import { API } from "./constants";

const AuthContext = createContext(null);
const TOKEN_KEY = "medstry_admin_token";

export function AuthProvider({ children }) {
  // user can be: false (no token), or {email, role} (have token; verified lazily)
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  // No on-mount verification — token presence is enough to render the dashboard;
  // each API call sends Bearer header and clears the session on 401.

  const login = async (email, password) => {
    const res = await axios.post(`${API}/admin/login`, { email, password });
    const t = res.data.access_token;
    localStorage.setItem(TOKEN_KEY, t);
    setToken(t);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
  };

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
  const isAuthenticated = Boolean(token);
  const user = isAuthenticated ? { email: "" } : false; // populated by dashboard via /me

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, user, login, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
